import { render } from "./add-topic.vue?vue&type=template&id=24cb6ae7"
import script from "./add-topic.vue?vue&type=script&lang=js"
export * from "./add-topic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__